import React, { Dispatch, SetStateAction, KeyboardEvent } from "react";
import classNames from "classnames";
export interface ICheckBox {
    label: string;
    isChecked: boolean;
    setIsChecked: Dispatch<SetStateAction<boolean>>;
    disabled?: boolean;
}
export const CheckBox = ({ label, isChecked, setIsChecked, disabled = false }: ICheckBox) => {
    const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (disabled) return;
        if (e.keyCode === 13 || e.keyCode === 32) {
            setIsChecked(!isChecked);
        }
    };

    const id = label
        .normalize("NFD")
        .trim()
        .toLowerCase()
        .replace(/æ/g, "ae")
        .replace(/ø/g, "oe")
        .replace(/a\u030a/g, "aa")
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9\-]/g, "");

    return (
        <div
            className={classNames("CheckBox__container", {
                "CheckBox__container--disabled": disabled,
            })}
        >
            <div
                className="CheckBox__checkbox"
                tabIndex={0}
                aria-labelledby={id}
                aria-checked={isChecked}
                onKeyDown={(e) => onKeyDown(e)}
            >
                <span
                    className={classNames("CheckBox__checkbox__icon", {
                        "CheckBox__checkbox__icon--checked": isChecked,
                    })}
                />
                <input
                    id={id}
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => {
                        setIsChecked(!isChecked);
                    }}
                    tabIndex={-1}
                />
            </div>
            <label htmlFor={id} className="CheckBox__label">
                {label}
            </label>
        </div>
    );
};
